<template>
  <div>
    <header-sales></header-sales>
    <div id="subheader"> </div>
    <div id="main-container">
      <div id="label-container">
        <span id="label">{{numeroPedido}}</span>
      </div>
      <div id= "container">
          <div id= "header-pedido">
              <div class="fh rc" style="width: 100%; height: 100%"> 
                  <div class="fh cb" style="font-size: 13px; color:#5D6770; margin-right: 30px">Subtotal: {{moneyLabel}} {{subtotal | formatMoney}} </div>
                  <div class="fh cb" style="font-size: 16px; color:#5D6770; margin-right: 36px; font-weight: 500">Total: {{moneyLabel}} {{total | formatMoney}} </div>
              </div>
          </div>
          <div id="list-container">
              <item-pedido id="list-prod" v-for="item in productosComp" :item='item' ></item-pedido>
          </div>
          <div class="fh cc" style="width: 630px; height: 7vh"> 
            <div class="fv cr" style="width: 50%; height: 35px; font-size: 10px; font-weight: 500; color:#5D6770">
                <div class="fh lb" style="height: 50%">
                   <div style="width: 105px"> Fecha de Alta:</div>
                   <div>{{this.splitFechaAlta}}</div>
                </div>
                <div class="fh lc" style="height: 50%">
                   <div style="width: 105px"> Fecha de Entrega:</div>
                   <div>{{this.pedido.FechaEntrega}}</div>
                </div>
            </div>
            <div class="fh rc" style="width: 50%;  height: 35px">
                <input id="btnReplicar" @click="btnReplicar" type="submit" value="REPLICAR  PEDIDO">
            </div>
          </div>
      </div>
    </div>
  </div>
</template>


  <script>
    import axios from 'axios'
    import HeaderSales from '@components/views/header.vue';
    import ItemPedido from '@components/views/estadoPedido/itemPedidoCms.vue';


    export default {
      name: 'Pedido',
      components:{
       'header-sales': HeaderSales,
       'item-pedido': ItemPedido,
      },

      data() {
         return {
           productos:[],
           replicaPedido:[],
           pedido:null,
         }
      },


      computed: {

        splitFechaAlta() {
            var f = this.pedido.Fecha.split(' ');
            return f[0];
        },

        moneyLabel() {
          if (this.$store.state.pedido.idMoneda == 2) {
           return 'U$S' 
          }
          else {
           return '$' 
          }
        },

        numeroPedido() {
          if (this.pedido != null) {
            return 'Pedido Nº ' + this.pedido.Numero
          }
          else {
            return 0
          }
        },

        fechaPedido() {
          if (this.pedido != null) {
            return this.pedido.Fecha
          }
          else {
            return ''
          }
        },

        items () {
          return this.$store.state.pedido.carrito;
        },

        subtotal () {
          if (this.$store.state.pedido.idMoneda == 2) {
            return this.pedido.MontoTotalDolar - this.pedido.CargoFleteUrgenteDolar - this.pedido.CargoPedidoMinimoDolar
          }
          else {
            return this.pedido.MontoTotal - this.pedido.CargoFleteUrgente - this.pedido.CargoPedidoMinimo
          }
        },

        total () {
          if (this.$store.state.pedido.idMoneda == 2) {
            return this.pedido.MontoTotalDolar 
          }
          else {
            return this.pedido.MontoTotal
          }
        },

        productosComp () {
          var auxProd = []
          var aux = []
          var recargo = 0.0
          var bonificacion = 0.0
          this.productos.forEach((j) => {  
              j.tipoOblea = 1
              auxProd.push(j) 
          });  
          if (this.pedido != null) {
            if (this.pedido.CargoPedidoMinimo > 0) {
                if (this.$store.state.pedido.idMoneda == 1) {
                recargo = this.pedido.CargoPedidoMinimo
                }
                else if (this.$store.state.pedido.idMoneda == 2) {
                recargo = this.pedido.CargoPedidoMinimoDolar
                }
                var i = { archivoId:0,
                        cantidad:1,
                        descripcion:'',
                        id:0,
                        idCategoria:0,
                        idSubcategoria:0,
                        peso:0,
                        Precio: recargo,
                        ProductoNombre:'Cargo por pedido mínimo',
                        tipoOblea:2
                }
                aux.push(i);
            }
            if (this.pedido.BonificacionCliente > 0) {
                if (this.$store.state.pedido.idMoneda == 1) {
                    bonificacion = this.pedido.BonificacionCliente
                }
                else if (this.$store.state.pedido.idMoneda == 2) {
                    bonificacion = this.pedido.BonificacionClienteDolar
                }
                var i = { archivoId:0,
                        cantidad:1,
                        descripcion:'',
                        id:0,
                        idCategoria:0,
                        idSubcategoria:0,
                        peso:0,
                        Precio: bonificacion,
                        ProductoNombre:'Bonificación del cliente',
                        tipoOblea:2
                }
                aux.push(i);
            }
            return auxProd.concat(aux);
          }
          else {
            return ''  
          }
        }
    },


    methods: {
      getPedido() {
        this.$store.commit('loader/start')
        var url = '/WebSalesPedidosListado?PedidoId='+String(this.$store.state.pedido.pedidoId);
        axios.get(url,{
          headers:{
                    Token: this.$store.state.user.usuario.Token,
                    ClientSecret: process.env.CLIENT_SECRET
                  }
        }).then((response) => {
            this.$store.commit('loader/stop')
            if (response.data.Code == 0) {
              this.pedido = response.data
              this.productos = response.data.Productos
            }
            else {
                var obj = {
                      txt: response.data.Message,
                      txtBtnCancel:'',
                      txtBtnOk:'Aceptar',
                      fCancel:null,
                      fOk:null
                    }
                this.$store.commit('popup/open',obj);
            }
        },
        (error) => {
            this.$store.commit('loader/stop')
            var obj = {
                txt: error.Message,
                txtBtnCancel:'',
                txtBtnOk:'Aceptar',
                fCancel:null,
                fOk:null
            }
            this.$store.commit('popup/open',obj);
        })

      },

      btnReplicar() {
        if (this.$store.state.pedido.carrito.length > 0)
        {
          var obj = {
                      txt:'Existe un nuevo pedido en curso, si replica el pedido actual los ítems cargados en el nuevo pedido se perderán.',
                      txtBtnCancel:'Cancelar',
                      txtBtnOk:'Replicar',
                      fCancel:null,
                      fOk:this.replicarPedidoGetProductos
                    }
          this.$store.commit('popup/open',obj);
        }
        else
        {
          this.replicarPedidoGetProductos();
        }
      },


      replicarPedidoGetProductos() 
      {
        this.$store.commit("loader/start");
        var idDep = this.pedido.DepositoId 
        var dep = this.$store.state.user.cliente.Depositos.find( elem => elem.Id === idDep)
        if (dep != null)
        {
          this.$store.commit("pedido/saveDeposito",dep);
        }

        var idCliente
        if (this.$store.state.user.usuario.EsEmpleado) {
          idCliente = this.$store.state.user.cliente.Id
        }
        else {
          idCliente = this.$store.state.user.usuario.ClienteId
        }

        var url = "/WebSalesProductos?DepositoId="+idDep+"&ClienteId="+idCliente;
        axios
            .get(url, {
              headers: {
                Token: this.$store.state.user.usuario.Token,
                ClientSecret: process.env.CLIENT_SECRET
              }
            })
            .then(
              response => {
                this.$store.commit("loader/stop");
                if (response.data.Code == 0) 
                {
                  this.$store.commit("pedido/saveProductos",response.data.Productos);
                  this.replicarPedido()
                }
                else if (response.data.Code == 99) 
                {
                  alert(response.data.Message);
                  this.$router.push({ name: "login" });
                }
                else
                {
                  console.log(">>>>" + response.data.Message);
                  alert(response.data.Message);
                }
              },
              error => {
                console.log(error);
                alert(error);
              }
            );
       },


    replicarPedido() {
        this.$store.commit('pedido/eliminarPedido');
        this.productos.forEach((e) => {
          if (e.ProductoId != 0) {
            var producto = this.$store.state.pedido.productos.find( elem => elem.Id === e.ProductoId)
            if (producto != null) {
                var nuevoProducto = {
                    archivoId:producto.ArchivoId,
                    cantidad: e.Cantidad,
                    codigo: producto.Codigo,
                    descripcion: producto.Nombre,
                    descuento: producto.Descuento,
                    esPromo:false,
                    id: producto.Id,
                    idCategoria: producto.CategoriaId,
                    idSubcategoria: producto.SubCategoriaId,
                    manejaStock: producto.ManejaStock,
                    pesoMinimoPedido: producto.PesoMinimoPedido,
                    peso: producto.EnvasePeso,
                    unidadesPorPedido: producto.UnidadesPorPedido,
                    precio: producto.Precio,
                    precioDeLista: producto.PrecioLista,
                    precioIngresado: producto.Precio,
                    producto: producto.Nombre,
                    promocionId:0,
                    stockActual: producto.StockActual,
                    tipoOblea:1
                }
                this.replicaPedido.push(nuevoProducto);
            }
          }
          else if (e.PromocionId != 0) {
            var promo = this.$store.state.pedido.promociones.find( elem => elem.Id === e.PromocionId)
            if (promo != null) {
                var nuevaPromo = {
                    id: 0,
                    esPromo:true,
                    diasEntrega:  promo.DiasEntrega,
                    idCategoria: promo.CategoriaId,
                    idSubcategoria: promo.SubCategoriaId,
                    tieneLimiteMaximo: promo.TieneLimiteMaximo,
                    limiteMaximo: promo.LimiteMaximo,
                    producto:promo.Nombre,
                    descripcion:promo.Nombre,
                    unidadesPorPedido: promo.UnidadesPorPedido,
                    precioIngresado:promo.PrecioPromocional,
                    cantidad: e.Cantidad,
                    peso:promo.Peso,
                    archivoId:promo.ArchivoId,
                    promocionId:promo.Id,
                    tipoOblea:1
                }
                this.replicaPedido.push(nuevaPromo);
            }
          }
        })
        this.$store.commit("loader/stop");
        this.$store.commit('pedido/replicarPedido',this.replicaPedido);
        this.$router.push({name: 'pedido'});
      }
    },


    mounted()
     {
      this.$store.commit('loader/stop')
      this.getPedido();
    }

  }


  </script>


  <style scoped>

  .boton:hover { cursor: pointer; }
  #btnClose:hover { cursor: pointer; }



  .fadePro-enter {
    opacity: 0;
  }
  .fadePro-enter-active {
    transition: opacity 0.5s;
  }
  .fadePro-enter-to {
    opacity: 1;
  }
  .fadePro-leave {
    opacity: 1;
  }
  .fadePro-leave-active {
    transition: opacity 0.1s;
  }
  .fadePro-leave-to {
    opacity: 0;
  }


  /*----------------------------*/

   #subheader {
   width: 100%;
   height: 35vh;
   background: linear-gradient(#005A9F , #1899D6);
   }


 #main-container{
  position: absolute;
  top: 55vh;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 700px;
  height: 85vh;
 }



#header-pedido{
 width: 700px;
 height: 65px;
 display: flex;
 flex-direction: row;
 justify-content: center;
 align-items: center;
}

#header-pedidoL{
 width: 260px;
 height: 100%;
 display: flex;
 flex-direction: row;
 background: #ffffff;
 justify-content: flex-start;
 align-items: center;
}

#header-pedidoR{
 width: 370px;
 height: 100%;
 display: flex;
 flex-direction: row;
 background: #ffffff;
 justify-content: flex-end;
 align-items: center;
}




 #label-container{
  width: 700px;
  height: 10vh;

 }

  #label{
  color:#ffffff;
  font-size: 27px;
 }


  .label-total{
  font-size: 16px;
  color:#5D6770;
  }

  .label-subtotal{
  font-size: 12px;
  color:#5D6770;
  }


  #container{
   width: 700px;
   height: 75vh;
   border-width: 1px;
   border: 1px solid #dddddd;
   box-sizing: border-box;
   box-shadow: 3px 3px 4px #dddddd;
   background-color: #ffffff;
   display: flex;
   flex-direction:column;
   align-items: center;
  }

  #list-container{
   width: 660px;
   height: 61vh;
   background: #ffffff;
   overflow: auto;
   display: flex;
   flex-direction:column;
   align-items: center;
   }


 #total-container{
  width: 660px;
  height: 7vh;
  display: flex;
  flex-direction:row;
  justify-content: flex-end;
  align-items: center;
}

.label2{
  font-size: 14px;
  color:#5D6770;
 }


#btnContainer{
  width: 660px;
  height: 7vh;
  display: flex;
  flex-direction:row;
  justify-content: flex-end;
  align-items: center;
}


  #btnReplicar{
    width: 120px;
    height: 30px;
    font-size: 9px;
    border-style: solid;
    border:none;
    background: #44C7F4;
    border-radius: 20px;
    color: #ffffff;
  }



  input[type="submit"]:hover
  {
    cursor: pointer;
  }


/* width */
  ::-webkit-scrollbar {
      width: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px #dddddd;
      border-radius: 10px;
  }


  /* Handle */
  ::-webkit-scrollbar-thumb {
      background: #bbbbbb;
      border-radius: 10px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
      background: #cccccc;
  }


  ::-webkit-scrollbar {
  display: block; }


  </style>



// WEBPACK FOOTER //
// src/components/views/estadoPedido/pedidoCms.vue